import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FETCH_SIGNUPCOUNTRY_ACTION,
  FETCH_SIGNUPCOUNTRY_SUCCESS_ACTION,
  FETCH_SIGNUPCOUNTRY_FAIL_ACTION,
  ADD_SIGNUP_ACTION,
  ADD_SIGNUP_FAIL_ACTION,
  ADD_SIGNUP_SUCCESS_ACTION,
} from "./action";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchCountry(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/countryCrncy", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_SIGNUPCOUNTRY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: FETCH_SIGNUPCOUNTRY_FAIL_ACTION,
      error: err,
    });
  }
}

function* signup(cred) {
  const signupValue = {
    name: cred.cred.name,
    lName: cred.cred.lName,
    callingCode: cred.cred.callingCode,
    email: cred.cred.email,
    country: cred.cred.country,
    mobileNo: cred.cred.mobileNo,
    password: cred.cred.password,
    role: cred.cred.role,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/users/user`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(signupValue),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: ADD_SIGNUP_SUCCESS_ACTION,
        payload: resJSON,
      });
      localStorage.setItem("UserRole", resJSON.user.role);
      localStorage.setItem("token", resJSON.token);
      localStorage.setItem("user", JSON.stringify(resJSON.user));

      if (
        resJSON.user.role === "shipper-enterprise" ||
        resJSON.user.role === "shipper-individual"
      ) {
        yield put(push("/profileupdate"));
      } else {
        yield put(push("/dashboard"));
        yield toast.success(
          "Account created successfully. Please login to continue",
          {
            autoClose: 3000,
            className:"toastClass"
          }
        );
      }
    }
  } catch (err) {
    if (err.status === 401) {
      yield toast.error("Invalid credentials", {
        autoClose: 3000,
        position: "top-right",
        className:"toastClass"
      });
    }
    if (err.status === 409) {
      yield toast.error("Email already registered", {
        autoClose: 3000,
        position: "top-right",
        className:"toastClass"
      });
    }

    yield put({
      type: ADD_SIGNUP_FAIL_ACTION,
      payload: err,
    });
  }
}

export function* SignupActionWatcher() {
  yield takeEvery(FETCH_SIGNUPCOUNTRY_ACTION, fetchCountry);
  yield takeEvery(ADD_SIGNUP_ACTION, signup);
}
